import styled from 'styled-components';
import theme from '../../UI/theme';

const Divider = styled.div`
    margin: ${props => props.marginVertical || '12'}px 0px;
    border-bottom: 2px solid ${theme.colors.darkSpace50};
`

export default Divider;